<template>
  <b-row class="pt-4 pb-2 mx-3">
    <b-col
      cols="12"
      class="d-none"
      :class="{ 'd-flex d-sm-none justify-content-end mb-5 pb-3 pb-md-0': isChildPage }"
    >
      <WChildAvatar
        v-bind="avatarParams"
        :class="{ 'child-card-avatar': isChildPage }"
        borderColor="var(--bs-mint-100)"
      />
    </b-col>
    <b-col
      :class="[
        'header-height px-0 px-md-3',
        { 'd-flex flex-column justify-content-center': !showWaitTime }
      ]"
    >
      <b-card-title
        class="text-blue-500 font-weight-bold mb-2 overflow-child-name"
        :class="[{ lead: !isChildPage, h2: isChildPage }]"
      >
        <b-skeleton
          v-if="loader"
          type="text"
          height="33px"
          animation="fade"
          width="200px"
        ></b-skeleton>
        <span v-else>{{ firstName }}</span>
      </b-card-title>
      <div :class="{ 'font-responsive': isChildPage }">
        <p
          :class="[
            'font-weight-normal text-blue-500',
            { lead: isChildPage },
            { 'mb-2': showWaitTime },
            { 'mb-1': !showWaitTime }
          ]"
        >
          <b-skeleton
            v-if="loader"
            type="text"
            animation="fade"
            width="100px"
            height="24px"
          ></b-skeleton>
          <span v-else>{{ childAge }}, {{ province.name }}</span>
        </p>
      </div>
      <div
        v-if="showWaitTime"
        :class="['text-danger d-flex align-items-start', { 'text-md': !isChildPage }]"
      >
        <b-skeleton
          v-if="loader"
          animation="fade"
          :height="isChildPage ? '36px' : '42px'"
          width="42px"
          class="mr-2"
        ></b-skeleton>
        <i v-else class="noun-clock pr-4 ml-n1"></i>
        <span v-if="!loader">
          {{ $t('childrenList.waitTime.prefix') }}
          <br v-if="!isChildPage" />
          {{ waitTime }}
        </span>
        <b-skeleton
          v-else
          :height="isChildPage ? '36px' : '42px'"
          width="100px"
          animation="fade"
        ></b-skeleton>
      </div>
    </b-col>
    <b-col cols="5" class="px-0 px-md-3" :class="{ 'd-none d-sm-block': isChildPage }">
      <WChildAvatar
        v-bind="avatarParams"
        :class="{ 'child-card-avatar': isChildPage || isFormOfSupportPage || isFormOfDonorData }"
        borderColor="var(--bs-mint-100)"
      />
    </b-col>
  </b-row>
</template>

<script>
// @TODO: add more variants to WiosnaUI ChildCard and remove this component from the project

import windowSize from '@/mixins/windowSize'

export default {
  name: 'ChildHeader',
  mixins: [windowSize],
  props: {
    firstName: {
      required: true,
      type: String
    },
    province: {
      required: true
    },
    birthyear: {
      required: true
    },
    daysWaiting: {
      type: Number,
      default: 0
    },
    childData: Object,
    showWaitingTime: {
      type: Boolean,
      default: true
    },
    loader: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    childAge() {
      const birthyear = parseInt(this.birthyear, 10)
      const currentYear = new Date().getFullYear()
      const age = currentYear - birthyear

      if (age && Number.isInteger(age)) {
        return `${age} ${this.$t('childrenList.card.age')}`
      }
      return ''
    },
    isChildPage() {
      return this.$route.name === 'ChildPage' || this.$route.name === 'ChildPageRetention'
    },
    isFormOfSupportPage() {
      return this.$route.name === 'FormOfSupport'
    },
    isFormOfDonorData() {
      return this.$route.name === 'FormOfDonorData'
    },
    waitTime() {
      if (this.daysWaiting >= 1) {
        let translateKey = ''
        if (this.daysWaiting === 1) {
          translateKey = 'childrenList.waitTime.oneDay'
        } else if (this.daysWaiting > 14) {
          translateKey = 'childrenList.waitTime.moreThan14Days'
        } else {
          translateKey = 'childrenList.waitTime.lessThan14Days'
        }
        return this.$t(translateKey, {
          days: this.daysWaiting
        })
      }
      return ''
    },
    showWaitTime() {
      return this.showWaitingTime && this.daysWaiting > 0
    },
    getChild() {
      return this.childData || this.$store.getters['child/getChild']
    },
    avatarParams() {
      const { avatar_id: avatarId } = this.childData
      const genderId = this.childData?.gender?.id
      return {
        avatarId,
        genderId,
        alt: 'Dziecko'
      }
    }
  }
}
</script>

<style scoped>
.header-height {
  min-height: 115px;
}
</style>
